import { z } from 'zod';

// @TBC --- we need to finish this schema when it's time
export const invoiceFilterSchema = z.object({});
export type InvoiceFilter = z.infer<typeof invoiceFilterSchema>;
